import { replaceDateObjectWithTimeStamp } from '@modules/common/utils';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';

export const useGetQuantifyQueryMetadata = () => {
  const queryMetadata = useQuantifyStore((state) => ({
    query: {
      ...state.query,
      groupBy: state.query.groupBy?.field,
      measuredAsCriteria: state.query.measuredAsCriteria?.field,
      duration: replaceDateObjectWithTimeStamp(state.query.duration),
      compareTo:
        state.query.compareTo?.type === 'timerange'
          ? {
              ...state.query.compareTo,
              duration: replaceDateObjectWithTimeStamp(
                state.query.compareTo.duration,
              ),
            }
          : state.query.compareTo,
    },
    metadata: state.metadata,
  }));

  return JSON.stringify(queryMetadata);
};
